import Login from "./Login"; // Основной компонент

export { Login }; // Экспортируем всё необходимое
export default Login; // Экспорт по умолчанию
